module.exports = __webpack_public_path__ + "media/images/blueimp/play-pause-20d7213b6d7d72174e131d3643849529.png";